var render, staticRenderFns
import script from "./TreeViewWithoutActions.vue?vue&type=script&lang=js&"
export * from "./TreeViewWithoutActions.vue?vue&type=script&lang=js&"
import style0 from "./TreeViewWithoutActions.vue?vue&type=style&index=0&id=296c924e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports